"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchTermSelector = exports.listModeSelector = exports.searchTermChanged = exports.listModeChanged = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
;
;
var slice = toolkit_1.createSlice({
    name: 'UI',
    initialState: {
        listMode: 'timeline',
        searchTerm: ''
    },
    reducers: {
        listModeChanged: function (state, action) {
            state.listMode = action.payload;
        },
        searchTermChanged: function (state, action) {
            state.searchTerm = action.payload;
        }
    }
});
var reducer = slice.reducer, actions = slice.actions;
exports.listModeChanged = actions.listModeChanged, exports.searchTermChanged = actions.searchTermChanged;
exports.listModeSelector = toolkit_1.createSelector(function (state) { return state.ui.listMode; }, function (listMode) { return listMode; });
exports.searchTermSelector = toolkit_1.createSelector(function (state) { return state.ui.searchTerm; }, function (searchTerm) { return searchTerm; });
exports.default = reducer;
